export const GET_FEES='GET_FEES';
export const ADD_FEES='ADD_FEES';
export const UPDATE_FEES='UPDATE_FEES';
export const DELETE_FEES='DELETE_FEES';
export const START_LOADING_FEES='START_LOADING_FEES';
export const END_LOADING_FEES='END_LOADING_FEES';

